{
  "table": {
    "key": "Clave",
    "ticker": "Ticker",
    "name": "Nombre",
    "exchange": "Intercambio",
    "currency": "Moneda",
    "currentPrice": "Precio actual",
    "originalCurrency": "Moneda original",
    "originalPrice": "Precio original",
    "primaryAssetClass": "Clase de activos primarios",
    "secondaryAssetClass": "Clase de activos secundarios",
    "substituteProduct": "Sustituto",
    "description": "Descripción",
    "tradeSchedule": "Calendario comercial",
    "planned": "Planificado",
    "noSchedule": "Sin horario",
    "taxRank": "Clasificación fiscal",
    "autoUpdatePrices": "Actualizar precios de forma automática",
    "fundSeries": "Serie de fondos",
    "cusip": "CUSIP",
    "fractional": "Fraccional",
    "volatile": "Volátil",
    "tertiaryAssetClass": "Clase de activos terciarios",
    "waivedFeePercentage": "Porcentaje de exención de tasas",
    "settlementDays": "Días de liquidación",
    "url": "URL",
    "isin": "ISIN",
    "ric": "RIC",
    "type": "Tipo",
    "multiplier": "Multiplicador",
    "yes": "Sí",
    "no": "No",
    "unselectAll": "Deseleccionar todas las páginas",
    "selectAll": "Seleccionar todas las páginas",
    "selectAllMessage": "Número total de filas seleccionadas: <bold>{{rowsCount}}</bold>",
    "allTypes": {
      "CASH_EQUIVALENTS": "Equivalentes de efectivo",
      "FIXED_INCOME": "Renta fija",
      "EQUITY": "Equidad",
      "MUTUAL_FUND": "Fondo de inversión",
      "ETF": "ETF",
      "DERIVATIVES": "Derivados",
      "ALTERNATIVE_INVESTMENTS": "Inversiones alternativas",
      "ANNUITY": "Anualidad",
      "CURRENCY": "Moneda",
      "OTHER": "Otros"
    },
    "currencyCurrentPriceCAD": "Precio actual (CAD)",
    "currencyCurrentPriceUSD": "Precio actual (USD)"
  },
  "productModal": {
    "editTitle": "Editar producto",
    "title": "Añadir al estante de productos",
    "ticker": "Ticker",
    "name": "Nombre",
    "exchange": "Intercambio",
    "originalCurrency": "Moneda original",
    "displayCurrency": "Mostrar moneda",
    "primaryAssetClass": "Clase de activos primarios",
    "secondaryAssetClass": "Clase de activos secundarios",
    "tertiaryAssetClass": "Clase de activos terciarios",
    "substituteProduct": "Producto financiero sustitutivo",
    "autoUpdatePrices": "Actualizar precios de forma automática",
    "organization": "Organización",
    "currentPrice": "Precio actual",
    "schedule": "Calendario",
    "illiquidMessage": "Añadir calendario comercial",
    "nextDate": "Próxima fecha",
    "waivedFeePercentage": "Porcentaje de exención de tasas (0 - 100 %)",
    "taxRank": "Clasificación fiscal",
    "volatile": "Volátil",
    "settlementDays": "Días de liquidación",
    "archive": "Archivar",
    "newProductToastMessage": "Ha añadido un producto financiero",
    "updateProductToastMessage": "Ha actualizado un producto financiero",
    "archiveToastMessage": "Ha archivado un producto financiero",
    "url": "URL",
    "isPartial": "Fraccional",
    "download": "Descargar historial de precios",
    "noHistoryToastMessage": "{{ticker}} no tiene historial de precios",
    "cusip": "CUSIP",
    "isin": "ISIN",
    "ric": "RIC",
    "alphaNumericErrorMessage": "Solo se permiten caracteres alfanuméricos.",
    "alphaNumericWithDotErrorMessage": "Solo se permiten caracteres alfanuméricos, posiblemente separados por un punto.",
    "zeroMultiplierErrorMessage": "El multiplicador no debe ser cero.",
    "cusipLengthErrorMessage": "Se requieren 9 o 22 caracteres.",
    "isinLengthErrorMessage": "Se requieren 12 caracteres.",
    "type": "Tipo",
    "fundSeries": "Serie de fondos",
    "allTypes": {
      "CASH_EQUIVALENTS": "Equivalentes de efectivo",
      "FIXED_INCOME": "Renta fija",
      "EQUITY": "Equidad",
      "MUTUAL_FUND": "Fondo de inversión",
      "ETF": "ETF",
      "DERIVATIVES": "Derivados",
      "ALTERNATIVE_INVESTMENTS": "Inversiones alternativas",
      "ANNUITY": "Anualidad",
      "CURRENCY": "Moneda",
      "OTHER": "Otros"
    },
    "multiplier": "Multiplicador",
    "duplicateProductErrorMessage": "Este producto ya existe. Seleccione otra combinación de ticker, bolsa u organización.",
    "currencyWarningMessage": "Advertencia: La moneda original ({{originalCurrency}}) difiere de la moneda predeterminada de la bolsa ({{exchangeCurrency}}).",
    "originalPrice": "Precio original",
    "currencyCurrentPriceCAD": "Precio actual (CAD)",
    "currencyCurrentPriceUSD": "Precio actual (USD)"
  },
  "assetClassModal": {
    "editTitle": "Editar clase de activo",
    "title": "Crear nueva clase de activo",
    "key": "Clave",
    "name": "Nombre",
    "description": "Descripción",
    "archive": "Archivar",
    "newAssetClassToastMessage": "Ha añadido una clase de activo",
    "archiveToastMessage": "Ha archivado una clase de activos"
  },
  "newGoalModal": {
    "title": "Añadir nueva meta"
  },
  "filters": {
    "isScheduled": "Planificado",
    "hasSubstitute": "Tiene productos sustitutivos",
    "primaryAssetClass": "Clase de activos primarios",
    "exchange": "Intercambio",
    "secondaryAssetClass": "Clase de activos secundarios",
    "moreFilters": "Filtros",
    "clearFilters": "Borrar filtros",
    "autoUpdatePrices": "Actualizar precios de forma automática"
  },
  "holdingDetailView": "Vista detallada de la tenencia",
  "tabs": {
    "details": "Detalles",
    "auditLog": "Registro de auditoría"
  },
  "auditLog": {
    "searchByProduct": "Buscar por producto",
    "startDate": "Fecha de inicio",
    "endDate": "Fecha de fin",
    "emptyState": "Aplique al menos un filtro para ver los registros de auditoría",
    "errorLoading": "No se pudo cargar el registro de auditoría",
    "invalidDateRange": "La fecha de fin debe ser igual o posterior a la fecha de inicio.",
    "clearDates": "Borrar fechas"
  }
}
